export const SWITCH_STUDENT_CART_MODAL_OPEN = 'SWITCH_STUDENT_CART_MODAL_OPEN';

export const SWITCH_STUDENT_ID = 'SWITCH_STUDENT_ID';
